import React, { useEffect, useState, createContext } from 'react'
import { BrowserRouter, Redirect, Switch, Route, useLocation } from 'react-router-dom'

import 'App.scss'
import StoryContent from './Exhibition2/StoryContent/StoryContent'
import Rooms from './Exhibition2/Rooms/Rooms'
import Mobile from './Exhibition2/Mobile'
import { useElementEvent } from './hooks'
import { updateCustomCursorPosition } from './Exhibition/helper'
import { CHAPTERS_ROUTES } from './constants'

export const UserClickedContext = createContext(false)

const ContextWrapper = ({ children }) => {
  let location = useLocation()
  const enterFullScreen = () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
      const doc = document.documentElement
      if (doc.requestFullscreen) {
        doc.requestFullscreen()
      } else if (doc.webkitRequestFullscreen) {
        doc.webkitRequestFullscreen()
      } else if (doc.msRequestFullscreen) {
        doc.msRequestFullscreen()
      }
    }
  }
  const [userClicked, setUserClicked] = useState(false)

  useElementEvent(
    'click',
    () => {
      setUserClicked(true)
      document.body.classList.add('userClicked')
      if (CHAPTERS_ROUTES.includes(location.pathname)) {
        enterFullScreen()
      }
    },
    document.body
  )

  useEffect(() => {
    if (!userClicked) {
      window.addEventListener('mousemove', updateCustomCursorPosition)
      window.addEventListener('touchmove', updateCustomCursorPosition)
    }

    return () => {
      window.removeEventListener('mousemove', updateCustomCursorPosition)
      window.removeEventListener('touchmove', updateCustomCursorPosition)
    }
  }, [userClicked])

  return <UserClickedContext.Provider value={userClicked}>{children}</UserClickedContext.Provider>
}

const App = () => {
  const [isDesktop, setDesktop] = useState(window.innerWidth > 960)

  const updateMedia = () => {
    setDesktop(window.innerWidth > 960)
  }

  useEffect(() => {
    window.addEventListener('resize', updateMedia)
    return () => window.removeEventListener('resize', updateMedia)
  })

  return isDesktop || window.location.search?.endsWith('id=5239d6a0-0425-4432-b6df-d06a3ed66537') ? (
    <BrowserRouter>
      <Switch>
        <Route path="/chapter">
          <ContextWrapper>
            <Rooms />
          </ContextWrapper>
        </Route>
        <Route path="/:name">
          <ContextWrapper>
            <StoryContent />
          </ContextWrapper>
        </Route>
        <Redirect exact from="/" to="/chapter?name=welcome" />
      </Switch>
    </BrowserRouter>
  ) : (
    <BrowserRouter>
      <Mobile />
    </BrowserRouter>
  )
}

export default App
